import React from "react";
import RegistrationFormCard from "./RegistrationFormCard";

const RegistrationCards = ({ items }) => {
  return (
    <div className="interest-form-grid">
      {items.map((item) => {
        return <RegistrationFormCard info={item} />;
      })}
    </div>
  );
};

export default RegistrationCards;
